(function () {

	/*
	Card Service
	*/

	"use strict";

	angular.module("swurveys.common")
	.factory("cardService", Handler);

	function Handler(utilsService, analyticsService, sliderService, currentSwurveyService, tutorialCardsService, $routeParams) {

		var firstCardHasBeenSwiped = false;
		var ownerId = currentSwurveyService.getSwurveyOwnerId();
		var disableSWOT;

		function createSliderAnswerCard(answeredCard) {
			var state = sliderService.getState();
			answeredCard.answer = answeredCard[state.selectedValue];
			if(answeredCard.answer) {
				answeredCard.answer.direction = state.selectedValue;
			}
		}

		function createAnswerCard(answeredCard, swipedDirection) {
			answeredCard.answer = answeredCard[swipedDirection];
			if(answeredCard.answer) {
				answeredCard.answer.direction = swipedDirection;
			}
		}

		function pushAnswerCard(swipedDirection, currentCard, answeredCardStack) {

			var answeredCard = currentCard.shift();

			var choice;

			if(answeredCard.type == "slider") {
				createSliderAnswerCard(answeredCard);
			} else if(utilsService.getQuestionCardTypes().indexOf(answeredCard.type) >= 0){
				//Ensure it's a question card.
				createAnswerCard(answeredCard, swipedDirection);
			}

			if(answeredCard.answer) {
				choice = answeredCard.answer.choice;
			}

			//We only care to collect the answer here if it's not the tutorial
			if(!answeredCard.isTutorialCard) {
				answeredCardStack.push(answeredCard);
			}

			//Our answered stack already has the card we just answered and only has customer cards in it
			//so its length is the cardinality we want
			analyticsService.trackCardSwipe(currentSwurveyService.getSwurveyId(), answeredCardStack.length, ownerId, choice);
			console.log("Answer:", answeredCardStack.length, choice);
			return answeredCard;
		}

		function initCardStack(model, cardStackOptions) {

			var currentCard = [];
			var currentCardIndex = 0;
			var answeredCardStack = [];
			var allCards = model.cards.slice();

			// Process cards
			model.cards.reverse();

			var WOTCard = {
				type: "SwurveyWOT",
				text: "SEE WHAT OTHERS THINK!",
				locked: true
			}

			model.cards.unshift(WOTCard);

			if (cardStackOptions.runTutorial.runIfFirstSwurvey) {
				tutorialCardsService.runTutorial(model, cardStackOptions.runTutorial.alwaysRun);
			}

			var next = function (swipedDirection) {
				var answeredCard;
				if(swipedDirection)
					answeredCard = pushAnswerCard(swipedDirection, currentCard, answeredCardStack);

				var answeredLength = answeredCardStack.length;
				var deckSize = model.cards.length;

				if(deckSize === 1) {
					cardStackOptions.lastCardSwiped(currentCard, allCards, answeredCardStack, disableSWOT);
				}

				var newCard;
				//A swiped direction(or choice) may have a 'next' member. This represents where to skip in the Swurvey 
				//It is either the ID of a later card, OR the keyword 'end' which means to just end
				var nextId;
				if(answeredCard && model.options && model.options.branching && model.options.branching.enabled)
				{
					if(answeredCard.next)
					{
						//We have content card that is going to skip ahead
						nextId = answeredCard.next;
					}
					if(answeredCard.answer && answeredCard.answer.next)
					{
						//OR the choice we answered will skip ahead.
						nextId = answeredCard.answer.next;
					}
				}
				if (nextId == "end") {
					//If the ID is 'end', then we pretend we just swiped the last card
					newCard = WOTCard;
					model.cards = []; //just get rid of the rest of the stack.
					cardStackOptions.lastCardSwiped(currentCard, allCards, answeredCardStack, disableSWOT);
				}
				else if (nextId) {
					//Else, we assume it's the ID of another card.
					//Pop off the model until we get to that card.
					do {
						newCard = model.cards.pop();
					} while (newCard.id != nextId)
				}
				else{
					newCard = model.cards.pop();
				}


				if(newCard) {
					if(newCard.type === 'slider') sliderService.initializeSlider();
					currentCard.push(newCard);
				}

				//The user is staring at the Cover Card
				if(currentCardIndex == 0 && !newCard.isTutorialCard) {
					cardStackOptions.coverCardShown(firstCardHasBeenSwiped);
				}

				if(currentCardIndex > 0) {
					cardStackOptions.eventModeDetected();
				}

				//The user is staring at the second card, either of the tutorial or of the Swurvey itself
				if(!firstCardHasBeenSwiped && (currentCardIndex == 1 || newCard.isSecondTutorialCard)) {
					cardStackOptions.firstCardSwiped();
					firstCardHasBeenSwiped = true;
				}

				//Our cardinality is only affected by user-created Swurvey cards
				if(newCard && !newCard.isTutorialCard)
					currentCardIndex++;


			}; //END OF NEXT FUNCTION

			cardStackOptions.initComplete();
			next();

			function getCurrentCards() {
				return currentCard;
			}

			function getCurrentCardIndex() {
				return currentCardIndex;
			}

			var cardStack = {
				currentCards: getCurrentCards,
				currentCardIndex: getCurrentCardIndex,
				swotAnimationComplete: false,
				next: next,
				WOT: undefined
			};

			return cardStack;
		} //END CARD STACK INIT

		return {
			initCardStack: initCardStack,
		}
	}

}());
